import { ThemeState, ThemeType } from "../context/theme";
import { Module } from "../lib/modules";
import { moduleRegistry } from "../lib/registry";
import { StateManager } from "../lib/stateManager";

interface NavState {}

export const Nav: Module<NavState> = () => {
  // Create a state manager with initial state
  const state = new StateManager<NavState>({});

  const setHeaderImage = (theme: ThemeType) => {
    const image = new Image();
    image.src = theme === "light" ? `/images/vgmm.svg` : `/images/vgmm-dark.svg`;
    const logoContainer = document.querySelector(".nav__logo") as HTMLDivElement;
    image.classList.add("nav__logo-image");
    image.setAttribute("alt", "Video Games Made Me Logo");
    image.setAttribute("width", "180px");
    image.setAttribute("height", "31px");
    logoContainer.innerHTML = "";
    logoContainer.appendChild(image);
  };

  const setThemeButton = (theme: ThemeType) => {
    const themeToggle = document.querySelector(".nav__theme-toggle") as HTMLDivElement;
    themeToggle.classList.remove("nav__theme-toggle--dark", "nav__theme-toggle--light");
    themeToggle.classList.add(`nav__theme-toggle--${theme}`);
  };

  const init = () => {
    attachEventListeners();

    const themeState = moduleRegistry.getState<ThemeState>("theme");
    if (themeState) {
      setHeaderImage(themeState.get("theme"));
      setThemeButton(themeState.get("theme"));
      themeState.onChange("theme", (newTheme) => {
        setHeaderImage(newTheme);
        setThemeButton(newTheme);
      });
    }
  };

  const toggleNavMenu = () => {
    const navMenu = document.querySelector(".nav__mobile-menu") as HTMLDivElement;
    const burger = document.querySelector(".nav__burger") as HTMLDivElement;
    navMenu.classList.toggle("nav__mobile-menu--open");
    burger.classList.toggle("nav__burger--open");
  };

  const attachEventListeners = () => {
    const navMenuButton = document.querySelector(".nav__burger") as HTMLDivElement;
    navMenuButton.addEventListener("click", toggleNavMenu);

    // Add theme toggle button handler
    const themeToggle = document.querySelector(".nav__theme-toggle") as HTMLDivElement;
    if (!themeToggle) {
      return;
    }
    themeToggle.addEventListener("click", () => {
      const themeState = moduleRegistry.getState<ThemeState>("theme");
      if (themeState) {
        const currentTheme = themeState.get("theme");
        const newTheme = currentTheme === "light" ? "dark" : "light";
        themeState.set("theme", newTheme);
        setHeaderImage(newTheme);
        setThemeButton(newTheme);
      }
    });
  };

  const detachEventListeners = () => {
    // Remove theme toggle button handler or other event listeners
    const navMenuButton = document.querySelector(".nav__burger") as HTMLDivElement;
    navMenuButton.removeEventListener("click", toggleNavMenu);
  };

  const destroy = () => {
    detachEventListeners();
  };

  return {
    init,
    attachEventListeners,
    detachEventListeners,
    destroy,
    state: state,
    pageBlacklist: ["/admin/*"],
    name: "nav"
  };
};
